import { useEffect, useState } from "react";

/**
 * 換頁時的骨架屏。用流光而不是轉圈圈，感覺比較快。
 *
 * ── 為什麼前 180 毫秒什麼都不畫 ────────────────────────────
 *
 * 這是 Suspense 的 fallback，而 Suspense 包住的是整個 Routes ——
 * 連頁首頁尾都在裡面。所以它一出現，整片版面就被換掉。
 *
 * 已經下載過的 chunk 換頁只要幾十毫秒。在那種情況下把整頁換成
 * 骨架再換回來，使用者看到的是一次劇烈的閃動 —— 而閃動讀起來
 * 像「出事了」，不像「載入中」。
 *
 * 前 180 毫秒回 null，等於：快到看不見的換頁就當它沒發生過。
 * 真的慢的時候（第一次進到某一頁、網路差）骨架才出來，
 * 而那時候它是有用的。
 *
 * 這段時間畫面上不是空的 —— 最上緣的進度條在 120 毫秒就開始跑，
 * 那是刻意錯開的：先給一個「有在動」的訊號，真的等比較久了
 * 才換上骨架。見 NavigationProgress。
 */
export default function PageSkeleton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const id = window.setTimeout(() => setShow(true), 180);
    return () => window.clearTimeout(id);
  }, []);

  if (!show) return null;

  return (
    <div
      className="mx-auto w-full max-w-7xl px-4 py-16 sm:px-6 lg:px-8"
      aria-busy
      /*
        淡入，不是直接出現。

        骨架本身就是一個過渡狀態，硬切進來會讓它自己變成一次
        版面跳動 —— 而它存在的理由正是要避免那件事。
      */
      style={{ animation: "skeleton-in 200ms ease-out both" }}
    >
      <div className="shimmer h-10 w-2/3 max-w-md rounded-lg" />
      <div className="mt-4 shimmer h-5 w-1/2 max-w-sm rounded" />
      <div className="mt-12 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rounded-card nm p-6">
            <div className="shimmer h-5 w-3/4 rounded" />
            <div className="mt-3 shimmer h-4 w-full rounded" />
            <div className="mt-2 shimmer h-4 w-5/6 rounded" />
            <div className="mt-6 flex gap-2">
              <div className="shimmer h-6 w-16 rounded-full" />
              <div className="shimmer h-6 w-20 rounded-full" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
